import React, { Component } from 'react';
import { connect } from 'react-redux';

import TagBadge from './TagBadge';
import MethodBadge from './MethodBadge';
import {AutoComplete, TextField} from 'material-ui';
import {http_methods} from '../utils';
import _ from 'lodash';

const style = {paddingBottom: '0px', paddingTop: '0px'};

const TagAutoCompleter = props => {
  const {tags, filter, ...rest} = props;
  const available = _(tags.toJS()).entries().filter(([key, avail]) => avail).map(([key, avail]) => key).value();
  return <AutoComplete menuCloseDelay={3600000} openOnFocus listStyle={style} menuStyle={style} floatingLabelText="Tag Filters" searchText={filter} dataSource={available} {...rest}/>;
};

class InfoBar extends Component {
  render() {
    const {tags, edit_mode, onRemoveTag, base_url, onUpdateBaseUrl} = this.props;
    let [available, used] = _(tags.toJS())
      .entries()
      .partition(kv => kv[1])
      .map(arr => arr.map(kv => kv[0]))
      .value();

    used = used.sort((a, b) => {
      const [first, second] = [a, b].map(val => http_methods.hasOwnProperty(val));
      return first && second ? a > b :
        first && !second ? -1 :
        !first && second ? 1 : a > b;
    });

    return <div style={{paddingLeft: '8px', display: 'table'}}>
      {edit_mode ? <TextField floatingLabelText='Base URL' value={base_url} onChange={e => onUpdateBaseUrl(e.target.value)}/> : null}
      <TagAutoCompleter tags={available} style={{display: 'table-cell'}} {...this.props}/>
      <div style={{display: 'table-cell', verticalAlign: 'middle'}}>
        {used.map(tag => http_methods[tag] ?
          <MethodBadge key={tag} className='glow' style={{margin: 5, padding: 5}} method={tag} onTouchTap={e => onRemoveTag(tag)}/> :
          <TagBadge key={tag} className='glow' tag={`#${tag}`} onTouchTap={e => onRemoveTag(tag)}/>
        )}
      </div>
    </div>;
  }
}

export default connect(
  state => ({
    tags: state.getIn(['tags', 'available'], {}),
    filter: state.getIn(['tags', 'filter']),
    base_url: state.getIn(['requests', 'base_url']),
    edit_mode: state.getIn(['apis', 'edit_mode'])
  }),
  dispatch => ({
    onUpdateInput(tag) {
      dispatch({type: 'UPDATE_TAG_AUTOCOMPLETE', data: tag});
    },
    onKeyDown(event) {
      event.stopPropagation();
    },
    onNewRequest(tag, index) {
      if (index !== -1) {
        dispatch({type: 'ADD_TAG_FILTER', data: tag});
      }
    },
    onRemoveTag(tag) {
      dispatch({type: 'REMOVE_TAG_FILTER', data: tag});
    },
    onUpdateBaseUrl(url) {
      dispatch({type: 'UPDATE_BASE_URL', data: url});
    }
  })
)(InfoBar);
